import { Box, Typography } from "@mui/material"
import PersonIcon from "@mui/icons-material/Person"
import { useAtom } from "jotai"
import { userAtom } from "@/common/state"
import IconButton from "@mui/material/IconButton"
import LoginModal from "@/components/users/LoginModal"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import MenuItem from "@mui/material/MenuItem"
import Menu from "@mui/material/Menu"
import showMe from "@/hooks/useGetMe"

const menuId = "primary-search-account-menu"

type UserProfile = [
  {
    user_number: number
    email: string
    display_name: string
    role: number
    profile_picture_link: string
  }
]

export const UserIcon = ({
  dimensions,
  borderRadius,
}: // children,
{
  dimensions: { width: string; height: string }
  borderRadius?: string
}) => {
  const [userProfile, setUserProfile] = useState<UserProfile>()
  useEffect(() => {
    showMe().then((profile: UserProfile) => {
      setUserProfile(profile)
    })
  }, [])
  // pulling user photo link from app state
  const [user] = useAtom(userAtom)
  const imageLink = user?.profilePicture

  const userPicture = userProfile
    ? userProfile[0]?.profile_picture_link
    : imageLink
  return (
    <>
      {userPicture ? (
        <img
          src={userPicture}
          alt="User profile picture"
          style={{
            width: dimensions.width,
            height: dimensions.height,
            borderRadius: borderRadius,
          }}
        />
      ) : (
        <Box
          sx={{
            backgroundColor: "#CCCCCC",
            width: dimensions.width,
            height: dimensions.height,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: ".3rem",
            borderRadius: borderRadius,
          }}
        >
          <PersonIcon
            sx={{
              width: "100%",
              height: "100%",
              color: "white",
              borderRadius: "50%",
            }}
          />
        </Box>
      )}
    </>
  )
}

const RenderMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const [user] = useAtom(userAtom)
  const canCreateEvents = user?.capabilities.includes("manage_events")

  return (
    <>
      <IconButton
        edge="end"
        id="basic-button"
        aria-label="account of current user"
        aria-controls={menuId}
        aria-haspopup="true"
        onClick={handleClick}
        color="default"
      >
        <UserIcon
          dimensions={{ width: "40px", height: "40px" }}
          borderRadius="50%"
        />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose} component={Link} to="/profile">
          <Typography>Profile</Typography>
        </MenuItem>
        <MenuItem component={Link} to="/logout">
          <Typography>Log out</Typography>
        </MenuItem>
        {canCreateEvents && (
          <MenuItem onClick={handleClose} component={Link} to="/admin/view">
            <Typography>Admin Panel</Typography>
          </MenuItem>
        )}
      </Menu>
    </>
  )
}

export const UserButton = () => {
  const [user] = useAtom(userAtom)

  return <>{user ? <RenderMenu /> : <LoginModal />}</>
}
